import React, { createRef, ReactElement, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import DeleteCardIcon from '../../../../../../assets/images/delete_card.svg';
import Container from './DeleteCardButton.styles';

export interface IDeleteCardButtonProps {
  handleClick: () => Promise<void>;
}

function DeleteCardButton(props: IDeleteCardButtonProps): ReactElement {
  const dropdownRef = createRef<HTMLDivElement>();
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  const handleToggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const onClick = () => {
    const { handleClick } = props;
    setShowDropdown(false);
    handleClick();
  };

  return (
    <Container ref={dropdownRef}>
      <button type="button" onClick={handleToggleDropdown} className="delete-card-button">
        ⋮
      </button>
      {showDropdown && (
        <div className="delete-card-button__dropdown">
          <button type="button" onClick={onClick} className="delete-card-button__dropdown-item">
            <img className="delete-card-button__icon" src={DeleteCardIcon} alt="delete card icon" />
            <FormattedMessage id="savedInstrument.card.delete.button" />
          </button>
        </div>
      )}
    </Container>
  );
}

export default DeleteCardButton;
